import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SkeletonLoaderShade } from '../../models/skeleton-loader.enum';

@Component({
  selector: 'f-skeleton-dynamic-table',
  template: `
    <kendo-grid
      [resizable]="false"
      [reorderable]="false"
      [scrollable]="'scrollable'"
      [data]="tableData()"
      class="h-100"
    >
      @if(showCheckboxColumn()){
      <kendo-grid-checkbox-column
        [resizable]="false"
        [reorderable]="false"
        [showSelectAll]="true"
        [width]="50"
        class="k-checkbox-column"
        headerClass="k-checkbox-column"
      >
        <ng-template kendoGridHeaderTemplate>
          <f-skeleton [class.k-checkbox]="true" [shape]="'rectangle'" [shade]="SkeletonLoaderShade.Dark"></f-skeleton>
        </ng-template>
        <ng-template kendoGridCellTemplate let-idx="rowIndex">
          <f-skeleton [class.k-checkbox]="true" [shape]="'rectangle'"></f-skeleton>
        </ng-template>
      </kendo-grid-checkbox-column>
      } @for(i of columns(); track $index){
      <kendo-grid-column [width]="columnWidth()">
        <ng-template kendoGridHeaderTemplate>
          <f-skeleton [shape]="'text'" [shade]="SkeletonLoaderShade.Dark"></f-skeleton>
        </ng-template>
        <ng-template kendoGridCellTemplate>
          <f-skeleton [shape]="'text'"></f-skeleton>
        </ng-template>
      </kendo-grid-column>
      }
    </kendo-grid>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireflyDynamicSkeletonTableComponent {
  readonly rowsCount = input<number>(30);
  readonly columnsCount = input<number>(10);
  readonly showCheckboxColumn = input<boolean>(true);
  readonly columnWidth = input<number>(170);
  SkeletonLoaderShade = SkeletonLoaderShade;

  readonly tableData = computed(() => {
    const count = this.rowsCount();
    const validCount = count > 0 ? Math.min(count, 30) : 30;
    return Array.from({ length: validCount }, (_, i) => i + 1);
  });

  readonly columns = computed(() => {
    const count = this.columnsCount();
    const validCount = count > 0 ? Math.min(count, 30) : 10;
    return Array.from({ length: validCount }, (_, i) => i + 1);
  });
}
